import React, { useCallback, useState, useEffect, createElement as _createElement } from 'react';
import classnames from 'classnames';
import { Text, Flex, Label, Content, Button } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import { TitleBar } from '@leverege/ui-plugin';
import Loading from './Loading';
import DeviceInput from './DeviceInput';
import Scan from './Scan';
import DeviceSearch from './DeviceSearch';
import InstallationDetails from './InstallationDetails';
import S from './Pair.css';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function PairForm(props) {
  const {
    desiredGatewayId,
    gatewayId,
    desiredGateway,
    gateway,
    powerSource,
    RSSI,
    placementNotes,
    image,
    gatewayNetworkId,
    onChange: pOnChange,
    onPair: pOnPair,
    areaClassName,
    footerClassName,
    onClose,
    titleVariant,
    titleIcon,
    actions,
    targetDesiredGatewayId,
    targetGatewayId
  } = props;
  const [activeScreen, setActiveScreen] = useState('main');
  const [activeField, setActiveField] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const onClick = useCallback(({
    data
  }) => {
    setActiveScreen(data.screen);
    setActiveField(data.field);
  }, [setActiveScreen, setActiveField]);
  const onFocusDesiredGateway = useCallback(({
    data
  }) => {
    setActiveScreen(data.screen);
    setActiveField(data.field);
  });
  const onFocusGateway = useCallback(({
    data
  }) => {
    setActiveScreen(data.screen);
    setActiveField(data.field);
  });
  const onChange = useCallback(evt => {
    if (evt.data === 'desiredGatewayId') {
      pOnChange({
        data: 'powerSource',
        value: evt.original?.data?.powerSource
      });
      pOnChange({
        data: 'RSSI',
        value: evt.original?.data?.zoneCalculationConfig?.minValue
      });
      pOnChange({
        data: 'placementNotes',
        value: evt.original?.data?.installNotes
      });
      pOnChange({
        data: 'floor',
        value: evt.original?.data?.floor?.id
      });
      pOnChange({
        data: 'zone',
        value: evt.original?.data?.zone?.id
      });
      pOnChange({
        data: 'position',
        value: {
          lat: evt.original?.data?.position?.lat,
          lon: evt.original?.data?.position?.lon
        }
      });
    }
    setActiveScreen('main');
    setActiveField(null);
    pOnChange(evt);
  }, [pOnChange]);
  useEffect(() => {
    let preloadTarget;
    if (targetDesiredGatewayId) {
      preloadTarget = {
        type: 'desiredGateways',
        id: targetDesiredGatewayId
      };
    }
    if (targetGatewayId) {
      preloadTarget = {
        type: 'gateways',
        id: targetGatewayId
      };
    }
    if (preloadTarget) {
      actions.parent().child('desiredGateways');
      GlobalState.dispatch(actions.parent().child(preloadTarget.type).itemActions(preloadTarget.id).get()).then(result => {
        const evt = {
          original: result,
          value: result.name,
          data: targetGatewayId ? 'gatewayId' : 'desiredGatewayId'
        };
        onChange(evt);
      });
    }
  }, []);
  const onPair = useCallback(async evt => {
    setLoading(true);
    try {
      await pOnPair();
      setActiveScreen('pairSuccess');
    } catch (err) {
      setError(err);
      setActiveScreen('pairFail');
    }
    setTimeout(() => setLoading(false), 250);
  }, [pOnPair]);
  const testExistingPairing = async evt => {
    const {
      data: {
        gateway,
        desiredGateway
      }
    } = evt;
    if (gateway?.data?.desiredGateway || desiredGateway?.data?.gateway) {
      if (gateway?.data?.desiredGateway) {
        let oldDesiredGatewayGroupActions;
        if (actions.relationship.objectType === 'desiredGateway') {
          oldDesiredGatewayGroupActions = actions;
        } else {
          oldDesiredGatewayGroupActions = actions.parent().child('desiredGateways');
        }
        try {
          // pull the old desired gateway into state so that the name
          // can be displayed later
          await GlobalState.dispatch(oldDesiredGatewayGroupActions.itemActions(gateway?.data?.desiredGateway.id).get());
        } catch (err) {
          console.log(`Could not retrieve old desired gteway ${gateway?.data?.desiredGateway.id}:`, err);
        }
      }
      setActiveScreen('AlreadyPaired');
    } else {
      onPair();
    }
  };
  const getSearchText = useCallback(selected => {
    if (activeField === 'gatewayId') {
      return selected?.name;
    }
    return selected?.data?.name;
  }, [activeField]);
  const goTo = useCallback(({
    data
  }) => {
    let action, primaryId, secondaryType, secondaryId;
    if (actions.relationship.objectType === 'desiredGateway') {
      primaryId = desiredGateway.id;
      secondaryId = gateway.id;
      secondaryType = 'gateway';
    } else {
      primaryId = gateway.id;
      secondaryId = desiredGateway.id;
      secondaryType = 'desiredGateway';
    }
    secondaryType = `${secondaryType}s`;
    if (actions.relationship.objectType === data) {
      action = actions.goTo(primaryId);
    } else {
      action = actions.parent().child(secondaryType).goTo(secondaryId);
    }
    GlobalState.dispatch(action);
    onClose();
  }, [desiredGateway, gateway, actions]);
  if (loading) {
    return /*#__PURE__*/_jsx(Content, {
      variant: "pairingContent|rootEditor",
      children: /*#__PURE__*/_jsx(Content.Area, {
        variant: "formBody",
        className: classnames(S.loadingArea, areaClassName),
        children: /*#__PURE__*/_jsx(Loading, {
          message: "Installing"
        })
      })
    });
  }
  let header;
  let content;
  let contentOverflow = {
    overflow: 'unset'
  };
  let footer;
  let body = null;
  switch (activeScreen) {
    case 'scan':
      content = /*#__PURE__*/_jsx(Scan, {
        ...props,
        gatewayNetworkId: gatewayNetworkId,
        eventData: activeField,
        onClick: onClick,
        onChange: onChange
      });
      break;
    case 'search':
      {
        const {
          [activeField]: val
        } = props;
        body = /*#__PURE__*/_createElement(DeviceSearch, {
          ...props,
          key: activeField,
          eventData: activeField,
          value: val,
          onChange: onChange,
          onClick: onClick,
          getSearchText: getSearchText
        });
        break;
      }
    case 'AlreadyPaired':
      contentOverflow = {
        overflow: 'auto'
      };
      header = /*#__PURE__*/_jsx(TitleBar, {
        variant: titleVariant,
        title: "Already installed",
        icon: titleIcon
      });
      content = /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("img", {
          className: S.successImage,
          width: 120,
          height: 120,
          alt: "failed to pair",
          src: "https://recovr-ui-assets.storage.googleapis.com/pair-question.png"
        }), /*#__PURE__*/_jsxs(Flex, {
          variant: "colXL",
          align: "center",
          children: [/*#__PURE__*/_jsx(Text, {
            variant: "formTitle",
            children: "Already installed"
          }), /*#__PURE__*/_jsx(AlreadyPairedMessage, {
            gateway: gateway,
            desiredGateway: desiredGateway
          })]
        })]
      });
      footer = /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: onClose,
          variant: "secondary",
          children: "Cancel"
        }), /*#__PURE__*/_jsx(Button, {
          variant: "primary",
          onClick: onPair,
          children: "Continue"
        })]
      });
      break;
    case 'pairSuccess':
      {
        header = /*#__PURE__*/_jsx(TitleBar, {
          variant: titleVariant,
          title: "Successfully Paired",
          icon: titleIcon
        });
        content = /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("img", {
            className: S.successImage,
            width: 120,
            height: 120,
            alt: "successfully paired",
            src: "https://recovr-ui-assets.storage.googleapis.com/pair-success.png"
          }), /*#__PURE__*/_jsxs(Flex, {
            variant: "colXL",
            align: "center",
            children: [/*#__PURE__*/_jsx(Text, {
              variant: "formTitle",
              children: "Success"
            }), /*#__PURE__*/_jsx(ErrorMessage, {
              gatewayId: gatewayId,
              desiredGatewayId: desiredGatewayId,
              error: error
            }), /*#__PURE__*/_jsxs("div", {
              className: S.buttonContainer,
              children: [/*#__PURE__*/_jsx(Button, {
                variant: "fakeList",
                eventData: "desiredGateway",
                onClick: goTo,
                children: desiredGatewayId
              }), /*#__PURE__*/_jsx(Button, {
                variant: "fakeList",
                eventData: "gateway",
                onClick: goTo,
                children: gatewayId
              })]
            })]
          })]
        });
        footer = /*#__PURE__*/_jsx(Button, {
          variant: "primary",
          onClick: onClose,
          children: "Done"
        });
        break;
      }
    case 'pairFail':
      {
        header = /*#__PURE__*/_jsx(TitleBar, {
          variant: titleVariant,
          title: "Failed to Pair",
          icon: titleIcon
        });
        content = /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("img", {
            className: S.successImage,
            width: 120,
            height: 120,
            alt: "failed to pair",
            src: "https://recovr-ui-assets.storage.googleapis.com/pair-failure.png"
          }), /*#__PURE__*/_jsxs(Flex, {
            variant: "colXL",
            align: "center",
            children: [/*#__PURE__*/_jsx(Text, {
              variant: "formTitle",
              children: "Failure"
            }), /*#__PURE__*/_jsx(ErrorMessage, {
              gatewayId: gatewayId,
              desiredGatewayId: desiredGatewayId,
              error: error
            })]
          })]
        });
        footer = /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsx(Button, {
            onClick: onClose,
            variant: "secondary",
            children: "Cancel"
          }), /*#__PURE__*/_jsx(Button, {
            variant: "primary",
            disabled: !desiredGatewayId || !gatewayId || loading,
            onClick: onPair,
            children: "Try Again"
          })]
        });
        break;
      }
    default:
      contentOverflow = {
        overflow: 'auto'
      };
      header = /*#__PURE__*/_jsx(TitleBar, {
        variant: titleVariant,
        title: "Install Gateway",
        icon: titleIcon
      });
      content = /*#__PURE__*/_jsxs(Flex, {
        variant: "colM",
        children: [/*#__PURE__*/_jsx(Text, {
          variant: "formTitle",
          children: "Install Gateway"
        }), /*#__PURE__*/_jsx(Text, {
          variant: "bodySmall",
          children: "Select the installation location and gateway."
        }), /*#__PURE__*/_jsx(Label, {
          variant: "inputTitle",
          children: "Installation Location"
        }), /*#__PURE__*/_jsx(DeviceInput, {
          hint: "Search Installation Location",
          eventData: "desiredGatewayId",
          value: desiredGatewayId,
          onChange: onChange,
          onFocus: onFocusDesiredGateway,
          onClick: onClick,
          scanEnabled: false
        }), /*#__PURE__*/_jsx(Label, {
          variant: "inputTitle",
          children: "Gateway ID"
        }), /*#__PURE__*/_jsx(DeviceInput, {
          hint: "Search Gateway ID",
          eventData: "gatewayId",
          value: gatewayId,
          onChange: onChange,
          onFocus: onFocusGateway,
          onClick: onClick
        }), desiredGatewayId && gatewayId && !loading && /*#__PURE__*/_jsx(InstallationDetails, {
          ...props,
          onChange: onChange,
          powerSource: powerSource,
          RSSI: RSSI,
          placementNotes: placementNotes,
          image: image
        })]
      });
      footer = /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: onClose,
          variant: "secondary",
          children: "Cancel"
        }), /*#__PURE__*/_jsx(Button, {
          variant: "primary",
          disabled: !desiredGatewayId || !gatewayId || !powerSource || !placementNotes || !image || loading,
          eventData: {
            gateway,
            desiredGateway
          },
          onClick: testExistingPairing,
          children: "Install"
        })]
      });
  }
  return /*#__PURE__*/_jsxs(Content, {
    variant: "pairingContent|rootEditor",
    children: [header && /*#__PURE__*/_jsxs(Content.Header, {
      variant: "formHeader",
      children: [header, /*#__PURE__*/_jsx(Button, {
        variant: "pairClose",
        className: S.close,
        onClick: onClose
      })]
    }), content && /*#__PURE__*/_jsx(Content.Area, {
      variant: "formBody",
      className: areaClassName,
      style: contentOverflow,
      children: content
    }), footer && /*#__PURE__*/_jsx(Content.Footer, {
      variant: "formButtons",
      className: classnames(S.footer, footerClassName),
      layout: "flex:rowMEnd",
      children: footer
    }), body]
  });
}
function ErrorMessage(props) {
  const {
    error,
    gatewayId,
    desiredGatewayId
  } = props;
  if (!error) {
    return null;
  }
  if (error.status === 400) {
    return /*#__PURE__*/_jsxs(Text, {
      children: ["Gateway ", /*#__PURE__*/_jsx("b", {
        children: gatewayId
      }), " was unable to pair with Installation Location ", /*#__PURE__*/_jsx("b", {
        children: desiredGatewayId
      }), "."]
    });
  }
  return /*#__PURE__*/_jsxs(Text, {
    children: ["Gateway ", /*#__PURE__*/_jsx("b", {
      children: gatewayId
    }), " was unable to pair with Installation Location ", /*#__PURE__*/_jsx("b", {
      children: desiredGatewayId
    }), " because of a network connection failure"]
  });
}
function AlreadyPairedMessage(props) {
  const {
    gateway,
    desiredGateway
  } = props;
  const oldGatewayId = desiredGateway.data?.gateway?.id;
  const oldGatewayName = desiredGateway.data?.gateway?.name || '(Unknown Name)';
  const newGatewayId = gateway.id;
  const newGatewayName = gateway.name || '(Unknown Name)';
  const oldDesiredGatewayId = gateway.data?.desiredGateway?.id;
  const newDesiredGatewayName = desiredGateway.name || '(Unknown Name)';
  let content = '';

  // reinstalling
  if (oldGatewayId && oldGatewayId === newGatewayId) {
    content = `${newGatewayName} is already installed at ${newDesiredGatewayName}. 
      Reinstalling will update installation information on ${newGatewayName}.`;
  } else {
    // new gateway already installed elsewhere
    if (oldDesiredGatewayId) {
      const {
        models: {
          lookup
        }
      } = GlobalState.get();
      const oldDesiredGatewayName = lookup[oldDesiredGatewayId]?.data?.name || '(Unknown Name)';
      content = `${newGatewayName} is already installed at ${oldDesiredGatewayName}`;
    }
    if (oldDesiredGatewayId && oldGatewayId) {
      content = `${content}, and `;
    }

    // new desired gateway already has a gateway
    if (oldGatewayId) {
      content = `${content}${oldGatewayName} is already installed at ${newDesiredGatewayName}`;
    }
    content = `${content}. Continuing installation will remove all exisiting installation information from `;
    if (oldGatewayId) {
      content = `${content}${oldGatewayName}`;
    }
    if (oldDesiredGatewayId && oldGatewayId) {
      content = `${content} and `;
    }
    if (oldDesiredGatewayId) {
      content = `${content}${newGatewayName}`;
    }
    content = `${content}, and install ${newGatewayName} at ${newDesiredGatewayName}.`;
  }
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      children: content
    }), /*#__PURE__*/_jsx(Text, {
      children: "Continue installation?"
    })]
  });
}